import React, { useState } from "react";

import Select from 'react-select';
import makeAnimated from 'react-select/animated';

const animatedComponents = makeAnimated();

export default function Multiselect({selectDefault, index, titleLists, handleChange, placeholder, isMultiselect=true}) {
  return (<div className=" mb-4">
    <Select
     styles={{
      control: (baseStyles, state) => ({
        ...baseStyles,
        width:'100%',
      }),
    }}
      closeMenuOnSelect={false}
      components={animatedComponents}
      onChange={(e)=> handleChange(e, index)}
      defaultValue={selectDefault}
      isMulti={isMultiselect}
      isSearchable
      placeholder={placeholder}
      options={titleLists}
    />
  </div>
  );
}